import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractService } from '@common/services/abstract.service';
import { EncryptionProviderService } from '@common/services/encryption.service';
import { HTTP_METHODS } from '@common/services/service.constant';
import { Platform, AlertController } from '@ionic/angular';
import { CommonService } from '@common/services/common.service';
import { Device } from '@ionic-native/device/ngx';

@Injectable({providedIn:'root'})
export class NewInvestorService extends AbstractService<any>{

   isUsCanadaResident: boolean;
   sipTenure: string;

    constructor(
      http: HttpClient,
      encryptionProviderService: EncryptionProviderService,platform: Platform,alertController:AlertController,commonService:CommonService, device:Device ){
      super(http, encryptionProviderService,platform,alertController,commonService,device);
    }

     //--------------Country API
     public getCountryData(data): Observable<any> {
        const url = '/country'
        return this.request({
          method: HTTP_METHODS.POST,
          url: `${url}`,
          body: data
        });
    }

    //--------------Master data API
    public getMasterData(data): Observable<any> {
        const url = '/master'
        return this.request({
          method: HTTP_METHODS.POST,
          url: `${url}`,
          body: data
        });
    }

    //--------------State and City list API
    public getStatAndCityData(data): Observable<any> {
      const url = '/statecity'
      return this.request({
        method: HTTP_METHODS.POST,
        url: `${url}`,
        body: data
      });
  }

  //--------------Solicit pan API
  public getSolicitPanData(data): Observable<any> {
    const url = '/solicit/pan'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data
    });
}

//--------------Get bank by IFSC code API
  public getBankByIfscCode(data): Observable<any> {
    const url = '/bank/bankdetails'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data
    });
  }

   ///--------------Scheme Details
   getFundDetails(data:any) {
    const url = '/admin/getFundDetails'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  ///--------------Systematic Frequency
  getSystematicFrequency(data: any) {
    const url = '/transaction/systematicFrequency'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }
  ///--------------List Schemes API
  getSchemeList(data:any) {
    const url = '/schemes'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  //---------------Search ARN (3 char)
  getDistributorArnList(data:any) {
    const url = '/search/arn'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  //---------------New Investor For SIP 
  sendSipData(data:any) {
    const url = '/investor/newsip'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  //---------------New Investor Purchase for Lumpsum 
  sendLumpsumData(data:any) {
    const url = '/investor/newpurchase'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  //---------------Get otp For NewInvestor Transaction 
  otpForNewInvestorTransaction(data: any) {
    const url = '/otp/investor'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  //---------------Validate otp For NewInvestor Transaction 
  validateOtpForNewInvestorrTransaction(data: any) {
    const url = '/otp/investor/validate'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  //---------------Resend otp For NewInvestor Transaction 
  resendOtpForNewInvestorTransaction(data: any) {
    const url = '/otp/investor/resend'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  //---------------Get NEFT Deatils
  getNeftBankDetails(data:any) {
    const url = '/bank/rtgsdetails'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }

  //---------------Get NEFT Deatils
  getRelationshipList() {
    const url = '/familyflag'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: {"source":"W"},
    });
  }

  setUsCanadaResident(isUsCanadaResident) {
    this.isUsCanadaResident = isUsCanadaResident;
  }

  getUsCanadaResident() {
    return this.isUsCanadaResident;
  }


  getSipMaxYearsAndMaxAmountDetails() {
    const url = '/transaction/getSipMaxYearsAndMaxAmountDetails'
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${url}`,
    });
  }

  setSipTenure(sipTenure) {
    this.sipTenure = sipTenure;
  }

  getSipTenure() {
    return this.sipTenure;
  }

    //--------------Validate Investor PAN API
    validateInvestorPan(data:any) {
      const url = '/investor/validateInvestorPan'
      return this.request({
        method: HTTP_METHODS.POST,
        url: `${url}`,
        body: data,
      });
  }

}